module.exports = __webpack_public_path__ + "190e37dac68556f10a48df4496696f36.MP3";